module.exports = __webpack_public_path__ + "img/action-gray.82d0bf83.svg";